module.exports = __webpack_public_path__ + "img/paper_airplane2_w.295f24c3.svg";